import { Activity, Hourglass, UserCheck, XCircle, CheckCircle2, Ban, Server, ClipboardCheck } from "lucide-react";
import { useExecution } from "@/store/executionStore";
import { MetricTile } from "@/components/hive/shared";

export function ExecutionOverview() {
  const executions = useExecution((s) => s.executions);
  const approvals = useExecution((s) => s.approvals);
  const health = useExecution((s) => s.systemHealth);

  const running = executions.filter((e) => e.status === "running").length;
  const waiting = executions.filter((e) => e.status === "waiting").length;
  const needsApproval = approvals.filter((a) => a.status === "pending").length;
  const failed = executions.filter((e) => e.status === "failed").length;
  const completed = executions.filter((e) => e.status === "completed").length;
  const cancelled = executions.filter((e) => e.status === "cancelled").length;
  const runnersOnline = health.filter((h) => h.status === "healthy").length;
  const decided = approvals.filter((a) => a.status !== "pending").length;

  const cards = [
    { label: "Running", value: running, icon: <Activity size={13} />, color: "#22d3ee", pulse: running > 0 },
    { label: "Waiting", value: waiting, icon: <Hourglass size={13} />, color: "#f59e0b" },
    { label: "Needs Approval", value: needsApproval, icon: <UserCheck size={13} />, color: "#a855f7", pulse: needsApproval > 0 },
    { label: "Failed", value: failed, icon: <XCircle size={13} />, color: "#f43f5e" },
    { label: "Completed", value: completed, icon: <CheckCircle2 size={13} />, color: "#22c55e" },
    { label: "Cancelled", value: cancelled, icon: <Ban size={13} />, color: "#94a3b8" },
    { label: "Runners Online", value: runnersOnline, icon: <Server size={13} />, color: "#38bdf8" },
    { label: "Approvals Decided", value: decided, icon: <ClipboardCheck size={13} />, color: "#10b981" },
  ];

  return (
    <div className="grid grid-cols-4 gap-2.5 px-4 pt-3 xl:grid-cols-8">
      {cards.map((c) => (
        <MetricTile key={c.label} label={c.label} value={c.value} icon={c.icon} color={c.color} pulse={c.pulse} />
      ))}
    </div>
  );
}
